
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/where-to-stay/[slug]",
      function () {
        return require("private-next-pages/where-to-stay/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/where-to-stay/[slug]"])
      });
    }
  